export * from '@/src/services/AppsFlyer/shared-exports'

export function useAppsFlyer() {
  // navigation on the web is already url-based, so deeplinking is already handled
}
